/**
 * Image Path Utility
 * 
 * Centralized function to get correct image paths for production vs development
 */

/**
 * Check if we're in production
 */
export function isProduction() {
    // Try Vite's import.meta.env first
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        if (import.meta.env.PROD) return true;
        if (import.meta.env.DEV) return false;
    }
    
    // Fallback: check hostname
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        return hostname !== 'localhost' && 
               hostname !== '127.0.0.1' && 
               hostname !== '';
    }
    
    // Default to development
    return false;
}

/**
 * Get the base path for images
 */
export function getImageBasePath() {
    return isProduction() ? './images' : './assets/images';
}

/**
 * Get full image path
 * @param {string} subpath - Subpath like 'ui/icon.png' or 'buildings/house.png'
 * @returns {string} Full path to image
 */
export function getImagePath(subpath) {
    const base = getImageBasePath();
    return `${base}/${subpath}`;
}

